export enum AlarmTypeEnum {
	  "TYPES-ALERT.unknown" = 0,
    "TYPES-ALERT.face_missing" = 1,
    "TYPES-ALERT.atten_warning" = 2,
    "TYPES-ALERT.look_around_warning" = 3,
    "TYPES-ALERT.phone_warning" = 4,
    "TYPES-ALERT.change_warning" = 5,
    "TYPES-ALERT.tired" = 6,
    "TYPES-ALERT.yawm_warning" = 7,
    "TYPES-ALERT.cam_coverd_warning" = 8,
    "TYPES-ALERT.smoke_warning" = 9,
    "TYPES-ALERT.impact" = 10,
    "TYPES-ALERT.pedestrian" = 11,
    "TYPES-ALERT.tail_gating" = 12,
    "TYPES-ALERT.swerving" = 13,
    "TYPES-ALERT.over_speed" = 14,
    "ALERTS-INFRACTIONS.infraction_type_over_speed" = 3003,
    "ALERTS-INFRACTIONS.infraction_type_no_seat_belt" = 3004,
    "ALERTS-INFRACTIONS.infraction_type_abrupt_break" = 3006,
    "ALERTS-INFRACTIONS.infraction_type_abrupt_speed" = 3007,
    "ALERTS-INFRACTIONS.infraction_type_abrupt_curve" = 3009,
    "ALERTS-INFRACTIONS.infraction_type_vibration" = 3010,
    "ALERTS-INFRACTIONS.infraction_type_device_removed" = 3011,
    "ALERTS-INFRACTIONS.infraction_type_device_no_battery" = 3012,
    "ALERTS-INFRACTIONS.infraction_type_device_sleep" = 3013,
    "TYPES-ALERT.calibration_error" = 162,
    "TYPES-ALERT.no_seatbelt" = 15,
    "TYPES-ALERT.fall" = 16,
    "TYPES-ALERT.low_spo2" = 17,
    "TYPES-ALERT.bradycardia" = 22,
    "TYPES-ALERT.tachycardia" = 23,
    "TYPES-ALERT.rider_detection" = 24,
    "TYPES-ALERT.drowsiness_l1_confirmation" = 25,
    "TYPES-ALERT.drowsiness_l2_confirmation" = 26,
    "TYPES-ALERT.speed" = 27,
    "TYPES-ALERT.sharp_turn" = 28,
    "TYPES-ALERT.hard_braking" = 29,
    "TYPES-ALERT.hard_acceleration" = 30,
    "TYPES-ALERT.stop_sign" = 31,
    "TYPES-ALERT.accumulated_drowsiness" = 32,
    "TYPES-ALERT.invalid_alarm" = 33,
    "TYPES-ALERT.rpm_infraction" = 46,
    "TYPES-ALERT.incompatible_glasses" = 45,
    "TYPES-ALERT.collision_risk_n1" = 47
}

export enum AlarmTypeEnumEN {
	  "TYPES-ALERT.unknown" = 0,
    "TYPES-ALERT.face_missing" = 1,
    "TYPES-ALERT.atten_warning" = 2,
    "TYPES-ALERT.look_around_warning" = 3,
    "TYPES-ALERT.phone_warning" = 4,
    "TYPES-ALERT.change_warning" = 5,
    "TYPES-ALERT.tired" = 6,
    "TYPES-ALERT.yawm_warning" = 7,
    "TYPES-ALERT.cam_coverd_warning" = 8,
    "TYPES-ALERT.smoke_warning" = 9,
    "TYPES-ALERT.impact" = 10,
    "TYPES-ALERT.pedestrian" = 11,
    "TYPES-ALERT.tail_gating" = 12,
    "TYPES-ALERT.swerving" = 13,
    "TYPES-ALERT.over_speed" = 14,
    "ALERTS-INFRACTIONS.infraction_type_over_speed" = 3003,
    "ALERTS-INFRACTIONS.infraction_type_no_seat_belt" = 3004,
    "ALERTS-INFRACTIONS.infraction_type_abrupt_break" = 3006,
    "ALERTS-INFRACTIONS.infraction_type_abrupt_speed" = 3007,
    "ALERTS-INFRACTIONS.infraction_type_abrupt_curve" = 3009,
    "ALERTS-INFRACTIONS.infraction_type_vibration" = 3010,
    "ALERTS-INFRACTIONS.infraction_type_device_removed" = 3011,
    "ALERTS-INFRACTIONS.infraction_type_device_no_battery" = 3012,
    "ALERTS-INFRACTIONS.infraction_type_device_sleep" = 3013,
    "TYPES-ALERT.calibration_error" = 162,
    "TYPES-ALERT.no_seatbelt" = 15,
    "TYPES-ALERT.fall" = 16,
    "TYPES-ALERT.low_spo2" = 17,
    "TYPES-ALERT.bradycardia" = 22,
    "TYPES-ALERT.tachycardia" = 23,
    "TYPES-ALERT.rider_detection" = 24,
    "TYPES-ALERT.drowsiness_l1_confirmation" = 25,
    "TYPES-ALERT.drowsiness_l2_confirmation" = 26,
    "TYPES-ALERT.speed" = 27,
    "TYPES-ALERT.sharp_turn" = 28,
    "TYPES-ALERT.hard_braking" = 29,
    "TYPES-ALERT.hard_acceleration" = 30,
    "TYPES-ALERT.stop_sign" = 31,
    "TYPES-ALERT.accumulated_drowsiness" = 32,
    "TYPES-ALERT.invalid_alarm" = 33,
    "TYPES-ALERT.rpm_infraction" = 46,
    "TYPES-ALERT.incompatible_glasses" = 45,
    "TYPES-ALERT.collision_risk_n1" = 47
}

export enum AlarmTypeEnumES {
	"TYPES-ALERT.unknown" = 0,
    "TYPES-ALERT.face_missing" = 1,
    "TYPES-ALERT.atten_warning" = 2,
    "TYPES-ALERT.look_around_warning" = 3,
    "TYPES-ALERT.phone_warning" = 4,
    "TYPES-ALERT.change_warning" = 5,
    "TYPES-ALERT.tired" = 6,
    "TYPES-ALERT.yawm_warning" = 7,
    "TYPES-ALERT.cam_coverd_warning" = 8,
    "TYPES-ALERT.smoke_warning" = 9,
    "TYPES-ALERT.impact" = 10,
    "TYPES-ALERT.pedestrian" = 11,
    "TYPES-ALERT.tail_gating" = 12,
    "TYPES-ALERT.swerving" = 13,
    "TYPES-ALERT.over_speed" = 14,
    "ALERTS-INFRACTIONS.infraction_type_over_speed" = 3003,
    "ALERTS-INFRACTIONS.infraction_type_no_seat_belt" = 3004,
    "ALERTS-INFRACTIONS.infraction_type_abrupt_break" = 3006,
    "ALERTS-INFRACTIONS.infraction_type_abrupt_speed" = 3007,
    "ALERTS-INFRACTIONS.infraction_type_abrupt_curve" = 3009,
    "ALERTS-INFRACTIONS.infraction_type_vibration" = 3010,
    "ALERTS-INFRACTIONS.infraction_type_device_removed" = 3011,
    "ALERTS-INFRACTIONS.infraction_type_device_no_battery" = 3012,
    "ALERTS-INFRACTIONS.infraction_type_device_sleep" = 3013,
    "TYPES-ALERT.calibration_error" = 162,
    "TYPES-ALERT.no_seatbelt" = 15,
    "TYPES-ALERT.fall" = 16,
    "TYPES-ALERT.low_spo2" = 17,
    "TYPES-ALERT.bradycardia" = 22,
    "TYPES-ALERT.tachycardia" = 23,
    "TYPES-ALERT.rider_detection" = 24,
    "TYPES-ALERT.drowsiness_l1_confirmation" = 25,
    "TYPES-ALERT.drowsiness_l2_confirmation" = 26,
    "TYPES-ALERT.speed" = 27,
    "TYPES-ALERT.sharp_turn" = 28,
    "TYPES-ALERT.hard_braking" = 29,
    "TYPES-ALERT.hard_acceleration" = 30,
    "TYPES-ALERT.stop_sign" = 31,
    "TYPES-ALERT.accumulated_drowsiness" = 32,
    "TYPES-ALERT.invalid_alarm" = 33,
    "TYPES-ALERT.rpm_infraction" = 46,
    "TYPES-ALERT.incompatible_glasses" = 45,
    "TYPES-ALERT.collision_risk_n1" = 47
}
